import React from 'react';
import {
  Loader,
  SvgSpinner,
  SvgExclamation,
  SvgCircleCheck,
  SvgCircleX,
} from '@grubhubprod/gh-cookbook-react';
import { Report, ReportStatus } from 'src/types/Report';

export enum ReportDisplayStatus {
  READY = 'READY',
  PENDING = 'PENDING',
  ERROR = 'ERROR',
  NO_DATA = 'NO_DATA',
}

export interface StatusIconSlot {
  Icon: React.ElementType<{ size?: string }>;
  size?: string;
}

export interface StatusConfig {
  column: StatusIconSlot;
  legend: StatusIconSlot;
  color: string;
  label: string;
}

export const STATUS_CONFIG: Record<ReportDisplayStatus, StatusConfig> = {
  [ReportDisplayStatus.READY]: {
    column: { Icon: SvgCircleCheck },
    legend: { Icon: SvgCircleCheck },
    color: 'success',
    label: 'Ready to download',
  },
  [ReportDisplayStatus.PENDING]: {
    column: { Icon: Loader, size: 'sm' },
    legend: { Icon: SvgSpinner },
    color: 'interactive',
    label: 'Pending',
  },
  [ReportDisplayStatus.ERROR]: {
    column: { Icon: SvgExclamation },
    legend: { Icon: SvgExclamation },
    color: 'danger',
    label: 'Report issue',
  },
  [ReportDisplayStatus.NO_DATA]: {
    column: { Icon: SvgCircleX },
    legend: { Icon: SvgCircleX },
    color: 'colorDisabled',
    label: 'No data available',
  },
};

export const transformReportStatusModelToUI = (
  report: Pick<Report, 'status' | 'downloadable'>
): ReportDisplayStatus => {
  switch (report.status) {
    case ReportStatus.EXPORT_STATUS_PENDING:
      return ReportDisplayStatus.PENDING;
    case ReportStatus.EXPORT_STATUS_ERROR:
      return ReportDisplayStatus.ERROR;
    case ReportStatus.COMPLETE:
    case ReportStatus.EXPORT_STATUS_COMPLETE:
      return report.downloadable
        ? ReportDisplayStatus.READY
        : ReportDisplayStatus.NO_DATA;
    default:
      return ReportDisplayStatus.NO_DATA;
  }
};
